import { render, staticRenderFns } from "./WebsiteSchulenCreateSubscription.vue?vue&type=template&id=8c5b3626&scoped=true"
import script from "./WebsiteSchulenCreateSubscription.vue?vue&type=script&lang=js"
export * from "./WebsiteSchulenCreateSubscription.vue?vue&type=script&lang=js"
import style0 from "./WebsiteSchulenCreateSubscription.vue?vue&type=style&index=0&id=8c5b3626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5b3626",
  null
  
)

export default component.exports